export default [
  {
    path: "/Agent",
    name: "中介信息管理",
    redirect: "/Agent/StoreSubAccount"
  },
  // 中介门店信息管理
  {
    path: "/Agent/StoreSubAccount",
    name: "中介门店信息管理",
    component: resolve =>
      require(["../components/StoreSubAccount/ShowStoreSubAccount"], resolve)
  },
  // 中介门店服务员信息管理
  {
    path: "/Agent/ClientInfo",
    name: "门店服务员信息管理",
    component: resolve =>
      require(["../components/ClientInfoGroup/ShowClientInfo"], resolve)
  },
  // 中介受托人及分组信息管理
  {
    path: "/Agent/ClientGroup",
    name: "分组信息管理",
    component: resolve =>
      require(["../components/ClientInfoGroup/ClientGroup"], resolve)
  },
  //订单统计
  {
    path: "/CaseStatistics",
    name: "订单统计",
    component: resolve =>
      require(["../components/CaseStatistics/CaseStatistics"], resolve)
  },
  {
    path: "/OrderStatistics",
    name: "订单统计",
    component: resolve =>
      require(["../views/OrderStatistics/index"], resolve)
  },
  {
    path: "/Agent/CaseDetail",
    name: "订单详情",
    component: resolve =>
      require(["../components/CaseStatistics/CaseDetail"], resolve)
  },
  {
    path: "/SupervisionOrders",
    name: "资金监管订单",
    component: resolve => require(["../views/SupervisionOrders/index"], resolve)
  },
  {
    path: "/CommissionSheet",
    name: "委托单",
    component: resolve => require(["../views/CommissionSheet/index"], resolve)
  }
];



// WEBPACK FOOTER //
// ./src/router/agent.js